import { render, staticRenderFns } from "./LazyloadLoadingLayout.vue?vue&type=template&id=7ef70984&scoped=true"
import script from "./LazyloadLoadingLayout.vue?vue&type=script&lang=js"
export * from "./LazyloadLoadingLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef70984",
  null
  
)

export default component.exports